import React from "react";
import FormatUtils from "../../common/formatUtils/FormatUtils";
import { ModalAlert } from "../../common/dialog/modalAlert";

export function ModalGestorConcessonaria(props) {
    const tipo = props.tipo || "energia";
    const nomeAtributoGestor = "gestor_concessionaria_" + tipo;

    if (!props.visible) return null;

    let gestor = null;

    if (props.itemSelecionado && props.itemSelecionado[nomeAtributoGestor]) {
        gestor = props.itemSelecionado[nomeAtributoGestor];
    }

    if (!gestor) {
        return (
            <ModalAlert titulo="Dados indisponíveis" handleClose={props.handleClose} showModal={props.visible}>
                <div style={{ padding: 20 }}>Nenhum dado do gestor encontrado.</div>
            </ModalAlert>
        );
    }

    return (
        <ModalAlert titulo={"Dados do Contato da " + gestor.nome_concessionaria} handleClose={props.handleClose} showModal={props.visible}>
            <div className="custom-scroll d-flex justify-content-center" style={{ maxHeight: 400, overflowY: "auto" }}>
                <table>
                    <tbody>
                        <tr>
                            <td style={{ fontWeight: "bold", padding: 10 }}>Nome:</td>
                            <td>{gestor.nome}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold", padding: 10 }}>Telefone:</td>
                            <td>{FormatUtils.formatarTelefone(gestor.telefone)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold", padding: 10 }}>E-mail:</td>
                            <td>{gestor.email}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ModalAlert>
    );
}
